// assets/eccp.js
(function () {
  // ---------------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------------

  function updateMainImage(productCard, imageUrl) {
    if (!productCard || !imageUrl) return;

    var mainImg = productCard.querySelector('.product-card__image--primary');
    if (!mainImg) return;

    mainImg.src = imageUrl;

    // Remove responsive attributes so browser doesn't try to re-resolve sizes
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
  }

  function updateMainLinkVariant(productCard, variantId) {
    if (!productCard || !variantId) return;

    var mainLink = productCard.querySelector('.product-card__figure > a');
    if (!mainLink || !mainLink.href) return;

    try {
      var url = new URL(mainLink.href);
      url.searchParams.set('variant', variantId);
      mainLink.href = url.toString();
    } catch (e) {
      // Fallback for older browsers: strip querystring and rebuild
      var base = mainLink.href.split('?')[0];
      mainLink.href = base + '?variant=' + encodeURIComponent(variantId);
    }
  }

  function setActiveSwatch(swatchLink) {
    if (!swatchLink) return;

    // Limit "active" state to the current swatch group
    var list = swatchLink.closest('.product-finish-images');
    if (!list) return;

    var active = list.querySelectorAll('.finish-swatch-link--active');
    for (var i = 0; i < active.length; i++) {
      active[i].classList.remove('finish-swatch-link--active');
    }

    swatchLink.classList.add('finish-swatch-link--active');
  }

  // ---------------------------------------------------------------------------
  // Event delegation for swatch clicks
  // ---------------------------------------------------------------------------

  document.addEventListener('click', function (event) {
    var swatchLink = event.target.closest('.finish-swatch-link');
    if (!swatchLink) return;

    // Prevent navigation; we just want to update the card image + link
    event.preventDefault();

    var imageUrl = swatchLink.dataset.mainImage;
    var variantId = swatchLink.dataset.variantId;

    if (!imageUrl) return;

    var productCard = swatchLink.closest('product-card');
    if (!productCard) {
      // Fallback if Impact ever wraps it differently:
      productCard = swatchLink.closest('.product-card');
    }
    if (!productCard) return;

    updateMainImage(productCard, imageUrl);
    if (variantId) {
      updateMainLinkVariant(productCard, variantId);
    }
    setActiveSwatch(swatchLink);
  });

  // ---------------------------------------------------------------------------
  // On DOM ready: preload images + set initial active swatch
  // ---------------------------------------------------------------------------

  document.addEventListener('DOMContentLoaded', function () {
    // Preload all variant images referenced by swatches to reduce lag
    var swatchLinks = document.querySelectorAll('.finish-swatch-link[data-main-image]');
    for (var i = 0; i < swatchLinks.length; i++) {
      var url = swatchLinks[i].dataset.mainImage;
      if (!url) continue;

      var img = new Image();
      img.src = url;
    }

    // Auto-mark the first swatch in each group as active (purely visual)
    var swatchLists = document.querySelectorAll('.product-finish-images');
    for (var j = 0; j < swatchLists.length; j++) {
      var first = swatchLists[j].querySelector('.finish-swatch-link');
      if (first) {
        first.classList.add('finish-swatch-link--active');
      }
    }
  });
})();
